import { render, staticRenderFns } from "./MaterialCleanup.vue?vue&type=template&id=4e6829d2&scoped=true"
import script from "./MaterialCleanup.vue?vue&type=script&lang=js"
export * from "./MaterialCleanup.vue?vue&type=script&lang=js"
import style0 from "./MaterialCleanup.vue?vue&type=style&index=0&id=4e6829d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6829d2",
  null
  
)

export default component.exports